export const messages: Array<{
  name: string;
  status: string;
  text: string;
  timestamp: any;
  color: string;
}> = [
  {
    name: 'another agent',
    status: 'available',
    text: "You're welcome. I'm glad we were able to get that figured out together",
    timestamp: new Date(
      new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).setHours(15, 30, 0, 0)
    ).toISOString(),
    color: '#FBC231',
  },
  {
    name: 'self',
    status: 'available',
    text: "This is a conversation about lunch so it isn't recorded at all and I'm very happy about that, because we were talking about Thai food. But I'm not really down with Thai food. So I was suggesting that we should grab burgers instead",
    timestamp: new Date(
      new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(10, 30, 0, 0)
    ).toISOString(),
    color: '#EE67AF',
  },
  {
    name: 'another agent',
    status: 'available',
    text: "I don't know. I had burgers yesterday. Pizza??",
    timestamp: new Date(
      new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(10, 40, 0, 0)
    ).toISOString(),
    color: '#FBC231',
  },
  {
    name: 'self',
    status: 'available',
    text: 'This is now a message that ia about my interaction with Peter. Does this needs to be tracked somehow?',
    timestamp: new Date(Date.now() - 15 * 60 * 1000).toISOString(),
    color: '#EE67AF',
  },
  {
    name: 'another agent',
    status: 'available',
    text: "Yeah, I can help you out with Peter. I'm available now, so what can I help you with?",
    timestamp: new Date(Date.now() - 5 * 60 * 1000).toISOString(),
    color: '#FBC231',
  },
];

export const groupMessages: Array<{
  name: string;
  status: string;
  text: string;
  timestamp: any;
  color: string;
}> = [
  {
    name: 'Jeff Davis',
    status: 'available',
    text: 'Lorem ipsum dolor sit amet consectetur. Pretium amet lacus mi nibh. Quisque felis dignissim risus amet aliquet adipiscing. Cras vitae dui augue enim fringilla nec.',
    timestamp: new Date(
      new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(10, 50, 0, 0)
    ).toISOString(),
    color: '#13DFCA',
  },
  {
    name: 'Jeff Davis',
    status: 'available',
    text: 'Lorem ipsum dolor sit amet consectetur. Pretium amet lacus mi nibh. Quisque felis dignissim risus amet aliquet adipiscing. Cras vitae dui augue enim fringilla nec.',
    timestamp: new Date(
      new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(10, 45, 0, 0)
    ).toISOString(),
    color: '#13DFCA',
  },
  {
    name: 'Shirley King',
    status: 'offline',
    text: 'Lorem ipsum dolor sit amet consectetur. Pretium amet lacus mi nibh. Quisque felis dignissim risus amet aliquet adipiscing. Cras vitae dui augue enim fringilla nec.',
    timestamp: new Date(
      new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(10, 40, 0, 0)
    ).toISOString(),
    color: '#FBC231',
  },
  {
    name: 'Norman Nelson',
    status: 'working',
    text: 'Lorem ipsum dolor sit amet consectetur. Pretium amet lacus mi nibh. Quisque felis dignissim risus amet aliquet adipiscing. Cras vitae dui augue enim fringilla nec.',
    timestamp: new Date(
      new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(10, 35, 0, 0)
    ).toISOString(),
    color: '#00B2FF',
  },
  {
    name: 'Shirley King',
    status: 'available',
    text: 'Lorem ipsum dolor sit amet consectetur. Pretium amet lacus mi nibh. Quisque felis dignissim risus amet aliquet adipiscing. Cras vitae dui augue enim fringilla nec.',
    timestamp: new Date(
      new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(10, 30, 0, 0)
    ).toISOString(),
    color: '#FBC231',
  },
  {
    name: 'Donna Wilson',
    status: 'busy',
    text: 'Lorem ipsum dolor sit amet consectetur. Pretium amet lacus mi nibh. Quisque felis dignissim risus amet aliquet adipiscing. Cras vitae dui augue enim fringilla nec.',
    timestamp: new Date(Date.now() - 15 * 60 * 1000).toISOString(),
    color: '#FF9000',
  },
  {
    name: 'Harvey Martin',
    status: 'offline',
    text: 'Lorem ipsum dolor sit amet consectetur. Pretium amet lacus mi nibh. Quisque felis dignissim risus amet aliquet adipiscing. Cras vitae dui augue enim fringilla nec.',
    timestamp: new Date(Date.now() - 5 * 60 * 1000).toISOString(),
    color: '#B266FF',
  },
];

export const agentsData: Array<{
  name: string;
  status: string;
  messages: typeof messages;
  isFavorite?: boolean;
  isMessageRead?: boolean;
}> = [
  {
    name: 'Jorge Rodriguez',
    status: 'available',
    messages: messages,
    isFavorite: true,
    isMessageRead: true,
  },
  {
    name: 'Lana Moore',
    status: 'busy',
    messages: messages,
    isFavorite: true,
    isMessageRead: true,
  },
  {
    name: 'Teri MacGyver',
    status: 'working',
    messages: messages,
    isFavorite: true,
    isMessageRead: true,
  },
  {
    name: 'Russell Thompson',
    status: 'available',
    messages: messages,
    isFavorite: true,
    isMessageRead: true,
  },
  {
    name: 'Barry Perez',
    status: 'available',
    messages: messages,
    isFavorite: true,
    isMessageRead: true,
  },
  {
    name: 'Marie Thompson',
    status: 'offline',
    messages: messages,
    isFavorite: true,
    isMessageRead: true,
  },
  {
    name: 'Pam wilson',
    status: 'working',
    messages: messages,
    isFavorite: true,
    isMessageRead: true,
  },
  {
    name: 'Samuel Perry',
    status: 'busy',
    messages: messages,
    isFavorite: true,
    isMessageRead: true,
  },
  {
    name: 'John Miller',
    status: 'available',
    messages: messages,
    isFavorite: false,
    isMessageRead: false,
  },
  {
    name: 'Sophie Cronin',
    status: 'available',
    messages: messages,
    isFavorite: false,
    isMessageRead: true,
  },
  {
    name: 'Jana Parker',
    status: 'working',
    messages: messages,
    isFavorite: false,
    isMessageRead: true,
  },
  {
    name: 'Zach Yundt',
    status: 'available',
    messages: messages,
    isFavorite: false,
    isMessageRead: true,
  },
  {
    name: 'Ellen cartwright',
    status: 'offline',
    messages: messages,
    isFavorite: false,
    isMessageRead: true,
  },
  {
    name: 'Bryan Zemalk',
    status: 'busy',
    messages: messages,
    isFavorite: false,
    isMessageRead: true,
  },
];

export const agentGroupsData: Array<{
  name: string;
  status: string;
  messages: typeof messages;
  groupMembers: any;
  isMessageRead?: boolean;
}> = [
  {
    name: 'Customer Service',
    status: 'available',
    messages: groupMessages,
    groupMembers: [
      'Jeff Davis',
      'Shirley King',
      'Norman Nelson',
      'Donna Wilson',
      'Harvey Martin',
    ],
    isMessageRead: false,
  },
  {
    name: 'Sandy Design Team',
    status: 'available',
    messages: groupMessages,
    groupMembers: [
      'Jeff Davis',
      'Shirley King',
      'Norman Nelson',
      'Donna Wilson',
      'Harvey Martin',
    ],
    isMessageRead: true,
  },
  {
    name: 'Sales',
    status: 'busy',
    messages: groupMessages,
    groupMembers: [
      'Jeff Davis',
      'Shirley King',
      'Norman Nelson',
      'Donna Wilson',
      'Harvey Martin',
    ],
    isMessageRead: true,
  },
  {
    name: 'UX/PMs',
    status: 'available',
    messages: groupMessages,
    groupMembers: [
      'Jeff Davis',
      'Shirley King',
      'Norman Nelson',
      'Donna Wilson',
      'Harvey Martin',
    ],
    isMessageRead: true,
  },
  {
    name: 'Research',
    status: 'available',
    messages: groupMessages,
    groupMembers: [
      'Jeff Davis',
      'Shirley King',
      'Norman Nelson',
      'Donna Wilson',
      'Harvey Martin',
    ],
    isMessageRead: true,
  },
];
